import { render, staticRenderFns } from "./BankAccountBaseForm.vue?vue&type=template&id=d426cc90&scoped=true&"
import script from "./BankAccountBaseForm.vue?vue&type=script&lang=ts&"
export * from "./BankAccountBaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountBaseForm.vue?vue&type=style&index=0&id=d426cc90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d426cc90",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
